import { jsx } from "react/jsx-runtime";
import { cleanProps, cn } from "../../utils/index.js";
import { headingVariants } from "../../variants/index.js";
function Heading({ children, className, ...props }) {
    const classes = cn(headingVariants(props), className);
    const Component = props.as || 'h1';
    return /*#__PURE__*/ jsx(Component, {
        className: classes,
        ...cleanProps(props, [
            'textStyle'
        ]),
        children: children
    });
}
export { Heading };
